export default __webpack_public_path__ + "f4ec05bb06ff2f77e2fcfd099f9eb1c3.png";